export default class ModalKformBuilderConfirmRemoveController {
	/* @ngInject */
	constructor($scope, $uibModalInstance) {
		this.$scope = $scope;
		this.$uibModalInstance = $uibModalInstance;
	}

	closeThisDialog(event) {
		this.$uibModalInstance.close(event);
	}
}
